import { render, staticRenderFns } from "./TuitionCardTemplatesList.vue?vue&type=template&id=3a9951a8&scoped=true&"
import script from "./TuitionCardTemplatesList.vue?vue&type=script&lang=ts&"
export * from "./TuitionCardTemplatesList.vue?vue&type=script&lang=ts&"
import style0 from "./TuitionCardTemplatesList.vue?vue&type=style&index=0&id=3a9951a8&lang=scss&scoped=true&"
import style1 from "./TuitionCardTemplatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9951a8",
  null
  
)

export default component.exports